import React from "react"
import { Box, Chip, Typography, List, ListItem } from "@mui/joy"
import { Tag } from "../Snippet"
import { Anchor } from "../Typography"
import { useTranslation } from 'react-i18next'
import { useFormatter } from "src/mtska-frontend-app-component/utils"
import CampaignAvatar from "../Snippet/CampaignAvatar"
import JSONPretty from 'react-json-pretty'

const InfoHeaderCampaignOperator = ({ item }) => {
    const { t } = useTranslation();
    const { formatDate } = useFormatter();

    const getCampaignStats = () => {
        if (!item?.campaignLeads) return { toRecall: 0, positive: 0 };

        const toRecall = item.campaignLeads.filter(lead =>
            lead.lastActivity?.activityOutcome.processStatus === 'wip'
        ).length;

        const positive = item.campaignLeads.filter(lead =>
            lead.lastActivity?.activityOutcome.processStatus === 'ok'
        ).length;

        const negative = item.campaignLeads.filter(lead =>
            lead.lastActivity?.activityOutcome.processStatus === 'ko'
        ).length;

        return { toRecall, positive, negative };
    };

    const stats = getCampaignStats();

    return (
        item?.updated_at ?
            <Box
                className="info-header info-header-campaign-operator"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'flex-start',
                    borderRadius: 'lg',
                    bgcolor: '#FFFFFF',
                    p: 3
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, flex: 1 }}>
                    <CampaignAvatar name={item?.name} url={item?.icon} item={item} />

                    <Box sx={{ flex: 1 }}>
                        <Typography
                            level="body-md"
                            sx={{
                                color: "var(--neutral-600)",
                                fontWeight: '500',
                                mb: 1
                            }}
                        >
                            {formatDate(item?.start_at)} - {formatDate(item?.end_at)}
                        </Typography>

                        <Typography
                            level="h1"
                            sx={{
                                color: "var(--customer-800)",
                                fontSize: '1.5rem',
                                fontWeight: '700',
                                mb: 2
                            }}
                        >
                            {item?.name}
                        </Typography>

                        <Box sx={{
                            display: 'flex',
                            gap: 3,
                            alignItems: 'center',
                            flexWrap: 'wrap'
                        }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Typography level="body-xs" sx={{ color: "var(--neutral-500)", fontWeight: '500' }}>
                                    {t('Stato')}
                                </Typography>
                                <Tag
                                //TODO aggiungi colore corretto per caso draft item?.editingstatus == "campaign_draft" ? "secondary" : "success"
                                    color={item?.editingstatus == "campaign_ready" ? "neutral" : item?.editingstatus == "campaign_new" ? "secondary" : "success"}
                                    dot
                                    label={t(item?.editingstatus)}
                                />
                            </Box>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Typography level="body-xs" sx={{ color: "var(--neutral-500)", fontWeight: '500' }}>
                                    {t('Tipologia')}
                                </Typography>
                                <Box sx={{ display: 'flex', gap: 0.5 }}>
                                    <Chip color="neutral" variant="outlined" size="sm">
                                        {t(item?.type) || '-'}
                                    </Chip>
                                    <Chip color="neutral" variant="outlined" size="sm">
                                        {t(item?.mode) || '-'}
                                    </Chip>
                                </Box>
                            </Box>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Typography level="body-xs" sx={{ color: "var(--neutral-500)", fontWeight: '500' }}>
                                    {t('Territorio')}
                                </Typography>
                                <Typography level="body-md" sx={{ fontWeight: '600' }}>
                                    {item?.selectedSegments?.[0]?.name || t('Nessun territorio')}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Typography level="body-xs" sx={{ color: "var(--neutral-500)", fontWeight: '500' }}>
                                    {t('Negativo')}
                                </Typography>
                                <Typography
                                    level="body-md"
                                    sx={{
                                        fontWeight: '700',
                                        color: "var(--danger-500)"
                                    }}
                                >
                                    {stats.negative}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Typography level="body-xs" sx={{ color: "var(--neutral-500)", fontWeight: '500' }}>
                                    {t('Da richiamare')}
                                </Typography>
                                <Typography
                                    level="body-md"
                                    sx={{
                                        fontWeight: '700',
                                        color: "var(--warning-400)"
                                    }}
                                >
                                    {stats.toRecall}
                                </Typography>
                            </Box>

                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                <Typography level="body-xs" sx={{ color: "var(--neutral-500)", fontWeight: '500' }}>
                                    {t('Positivo')}
                                </Typography>
                                <Typography
                                    level="body-md"
                                    sx={{
                                        fontWeight: '700',
                                        color: "var(--success-600)"
                                    }}
                                >
                                    {stats.positive}
                                </Typography>
                            </Box>
                        </Box>

                        {(item?.email || item?.telephone || item?.mobile) && (
                            <List
                                orientation="horizontal"
                                sx={{ gap: 2, m: 0, mt: 2, alignItems: 'center' }}
                            >
                                {item?.email && (
                                    <ListItem sx={{ p: 0 }}>
                                        <Anchor icon="faEnvelope" iconfamily="fal" href={`mailto:${item?.email}`}>
                                            {item?.email}
                                        </Anchor>
                                    </ListItem>
                                )}
                                {item?.telephone && (
                                    <ListItem sx={{ p: 0 }}>
                                        <Anchor icon="faPhone" iconfamily="fal" href={`tel:${item?.telephone || ''}`}>
                                            {item?.telephone}
                                        </Anchor>
                                    </ListItem>
                                )}
                                {item?.mobile && (
                                    <ListItem sx={{ p: 0 }}>
                                        <Anchor icon="faPhone" iconfamily="fal" href={`tel:${item?.mobile || ''}`}>
                                            {item?.mobile}
                                        </Anchor>
                                    </ListItem>
                                )}
                            </List>
                        )}
                    </Box>
                </Box>
            </Box>

            :
            <Box
                className="info-header info-header-campaign-operator"
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderRadius: 'lg',
                    bgcolor: '#FFFFFF',
                    p: 3
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Box sx={{ flex: 1 }}>
                        <Typography level="h2" sx={{ mb: 1.5, mt: 1, color: "var(--neutral-400)", fontWeight: '200' }}>
                            {t('New campaign')}
                        </Typography>
                    </Box>
                </Box>
            </Box>
    )
}

export default InfoHeaderCampaignOperator